export default __webpack_public_path__ + "static/media/00.df3189b8.jpg";